import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from 'shared/components/loading/loading.module';
import { SmartResponsesComponent } from './smart-responses.component';

@NgModule({
  imports: [
    CommonModule,
    LoadingModule,
    TranslateModule
  ],
  providers: [
  ],
  declarations: [
    SmartResponsesComponent
  ],
  exports: [
    SmartResponsesComponent
  ]
})
export class SmartResponsesModule {}
